import {NavItem} from "@components/default/AppHeader.tsx";
import {
	BancoDadosIcon,
	CadastrosIcon,
	CaminhoesIcon,
	ClientesIcon,
	ColecoesIcon,
	DashboardsIcon,
	DashboardsPedidosIcon,
	FamiliasIcon,
	FornecedoresIcon,
	LogisticaIcon,
	NotasFiscaisIcon,
	PaletesIcon,
	PessoasIcon,
	ProdutosIcon,
	RegrasIcon,
	RepresentantesIcon,
	RolesIcon,
	SegurancaIcon,
	SenhaIcon,
	SimulacaoCargaIcon,
	TabelasPrecosIcon,
	UsuariosIcon,
	VendasIcon
} from "../../images/svgs/MenuIcons.tsx";
import {
	IconBox,
	IconBuildingStore,
	IconBuildingWarehouse,
	IconKey,
	IconRoute,
	IconShoppingBag,
	IconTrendingUp2,
	IconWorldSearch
} from '@tabler/icons-react';

export const menuItems: NavItem[] = [
	{
		text: 'Cadastros',
		permissions: [{modulo: 'produto'},
			{modulo: 'representante'},
			{modulo: 'cliente'},
			{modulo: 'regra'},
			{modulo: 'caminhao'},
			{modulo: 'notaFiscal'},
			{modulo: 'bancoDeDados'},
			{modulo: 'logistica'},
		],
		icon: <CadastrosIcon/>,
		children: [
			{
				text: 'Produtos',
				icon: <ProdutosIcon/>,
				path: '/produtos',
				hide: 'without permission',
				permissions: [{modulo: 'produto'}]
			},
			{
				text: 'Famílias',
				icon: <FamiliasIcon/>,
				path: '/produtos/familias',
				hide: 'without permission',
				permissions: [{modulo: 'produto'}]
			},
			{
				text: 'Coleções',
				icon: <ColecoesIcon/>,
				path: '/produtos/colecoes',
				hide: 'without permission',
				permissions: [{modulo: 'produto'}]
			},
			{
				text: 'Representantes',
				icon: <RepresentantesIcon/>,
				path: '/representantes',
				hide: 'without permission',
				permissions: [{modulo: 'representante'}]
			},
			{
				text: 'Clientes',
				icon: <ClientesIcon/>,
				permissions: [{modulo: 'cliente'}],
				children: [
					{
						text: 'Clientes',
						icon: <ClientesIcon/>,
						path: '/clientes',
						permissions: [{modulo: 'cliente'}],
					},
					{
						text: 'Proporção de atendimento',
						icon: <IconWorldSearch size={18} />,
						path: '/clientes/ufs-atendimento',
						permissions: [{
							modulo: 'cliente',
							tipo: 'visualizar',
							acao: 'clientes_por_cidade'
						}, {modulo: 'cliente', tipo: 'visualizar', acao: 'clientes_por_uf'}],
					}
				]
			},
			{
				text: 'Fornecedores',
				icon: <FornecedoresIcon/>,
				path: '/fornecedores',
				hide: 'without permission',
				permissions: [{modulo: 'notaFiscal'}]
			},

			{
				text: 'Tabelas de preços',
				icon: <TabelasPrecosIcon/>,
				path: '/tabelaprecos',
				hide: 'without permission',
				permissions: [{modulo: 'produto'}]
			},
			{
				text: 'Banco de dados',
				icon: <BancoDadosIcon/>,
				hide: 'without permission',
				permissions: [{modulo: 'bancoDeDados'}],
				children: [{
					text: 'Tabelas',
					icon: <BancoDadosIcon/>,
					path: '/erpdb/tabelas',
					permissions: [{modulo: 'bancoDeDados'}],
				}]
			},
			{
				text: 'Logistica', icon: <LogisticaIcon/>,
				children: [
					{
						text: 'Caminhões',
						icon: <CaminhoesIcon/>,
						path: '/caminhoes',
						hide: 'without permission',
						permissions: [{modulo: 'caminhao'}]
					},
					{
						text: 'Paletes',
						icon: <PaletesIcon/>,
						path: '/caminhoes/paletes',
						hide: 'without permission',
						permissions: [{modulo: 'caminhao'}]
					},
					{
						text: 'Depositos',
						icon: <IconBuildingWarehouse size={18} />,
						path: '/logistica/depositos',
						hide: 'without permission',
						permissions: [{modulo: 'logistica'}]
					},
					{
						text: 'Etapas de Rastreio',
						icon: <IconRoute size={18} />,
						path: '/logistica/cargas/etapas',
						hide: 'without permission',
						permissions: [{modulo: 'etapas', tipo: 'alterar'}, {modulo: 'etapas', tipo: 'criar'}]
					}
				]
			},
			{
				text: 'Regras de negócios',
				icon: <RegrasIcon/>,
				hide: 'without permission',
				children: [
					{
						text: 'Regras de aprovação',
						icon: <RegrasIcon/>,
						path: '/regras',
						hide: 'without permission',
						permissions: [{modulo: 'regra'}]
					}
				],
				permissions: [{modulo: 'regra'}]
			},
		]
	},
	{
		text: 'Mercado',
		icon: <IconBuildingStore stroke={2}/>,
		hide: 'without permission',
		children: [
			{
				text: 'Força de vendas',
				icon: <VendasIcon/>,
				hide: true,
				children: [
					{text: 'Pedidos de vendas', icon: <VendasIcon/>, path: '/forca-vendas', hide: true}
				],
				permissions: [{modulo: 'pedido'}]
			},
			{
				text: 'Notas fiscais',
				icon: <NotasFiscaisIcon/>,
				hide: 'without permission',
				children: [
					{text: 'Notas fiscais (Entrada)', icon: <NotasFiscaisIcon/>, path: '/nf/entrada'},
					{text: 'Notas fiscais (Saida)', icon: <NotasFiscaisIcon/>, path: '/nf/saida'}
				],
				permissions: [{modulo: 'notaFiscal'}]
			}, {
				text: 'Pedidos',
				icon: <IconTrendingUp2 stroke={2}/>,
				hide: 'without permission',
				children: [
					{
						text: 'Pedidos de venda',
						icon: <IconTrendingUp2 stroke={2}/>,
						path: '/pedidos/venda'
					}
				],
				permissions: [{modulo: 'pedido', tipo: 'visualizarTudo'}]
			},

		],
		permissions: [{modulo: 'pedido', tipo: 'visualizarTudo'}, {modulo: 'notaFiscal'}]
	},
	{
		text: 'Sofrimentos',
		icon: <IconBox stroke={2}/>,
		hide: 'without permission',
		permissions: [{modulo: 'compras'}],
		children: [
			{
				text: 'Requisições',
				icon: <IconShoppingBag size={18} />,
				path: '/compras'
			}
		]
	},
	{
		text: 'Pessoas',
		icon: <PessoasIcon/>,
		hide: 'without permission',
		children: [{
			text: 'Pessoas',
			icon: <PessoasIcon/>,
			path: '/pessoas'
		}],
		permissions: [{modulo: 'colaboradores', tipo: 'visualizarTudo'}]
	},
	{
		text: 'Logistica',
		icon: <LogisticaIcon/>,
		hide: 'without permission',
		permissions: [{modulo: 'logistica'}],
		children: [{
			text: 'Cargas',
			icon: <CaminhoesIcon/>,
			hide: 'without permission',
			permissions: [{modulo: 'logistica'}],
			children: [{
				text: 'Simulação de carga',
				icon: <SimulacaoCargaIcon/>,
				path: 'logistica/cargas/simulacoes',
				hide: 'without permission',
				permissions: [{modulo: 'logistica'}]
			},
				{
					text: 'Cargas por prefaturas',
					icon: <CaminhoesIcon/>,
					path: '/logistica/cargas',
					hide: 'without permission',
					permissions: [
						{modulo: 'logistica'},
						{modulo: 'pedido'},
					]
				},
				{
					text: 'Cargas Detalhadas',
					icon: <CaminhoesIcon/>,
					path: '/logistica/cargas/detalhes',
					hide: 'without permission',
					permissions: [
						{modulo: 'logistica'},
						{modulo: 'pedido'},
					]
				},
			]
		}]
	}, {
		text: 'Dashboards',
		icon: <DashboardsIcon/>,
		hide: 'without permission',
		children: [
			{
				text: 'Vendas',
				icon: <DashboardsPedidosIcon/>,
				permissions: [{modulo: 'pedido', tipo: 'visualizarTudo'}],
				children: [
					{
						text: 'Pedidos',
						hide: 'without permission',
						icon: <DashboardsPedidosIcon/>,
						path: '/dashboards/pedidos',
						permissions: [{modulo: 'TO_IGNORE', tipo: 'visualizarTudo'}]
					},
					{
						text: 'Pedidos (ERP)',
						hide: 'without permission',
						icon: <DashboardsPedidosIcon/>,
						path: '/pedidos/venda/graficos',
						permissions: [{modulo: 'pedido', tipo: 'visualizarTudo'}]
					}
				],
			},
		],
		permissions: [{modulo: 'pedido', tipo: 'visualizarTudo'}]
	},
	{
		text: 'Segurança',
		icon: <SegurancaIcon/>,
		children: [
			{
				text: 'Roles',
				icon: <RolesIcon/>,
				path: '/roles',
				hide: 'without permission',
				permissions: [{modulo: 'role'}]
			},
			{
				text: 'Usuários',
				icon: <UsuariosIcon/>,
				path: '/usuarios',
				hide: 'without permission',
				permissions: [{modulo: 'usuario'}]
			},
			{
				text: 'Alterar senha',
				icon: <SenhaIcon/>, path: '/conta/alterarsenha'
			},
			{
				text: 'Gerar senha',
				icon: <IconKey size={18} />,
				path: '/conta/gerarsenha'
			}
		],
	},

];